/**
 * Display label for an order line: product name - variation (when present).
 */
export function buildOrderLineItemLabel(li) {
  if (!li?.name) return '';
  let lineName = String(li.name).replace(/^Select:\s*/i, '');
  let variation = String(li.variation_label || li.variation || '').replace(/^Select:\s*/i, '');
  if (variation && lineName.includes(variation)) variation = '';
  const qty = Number(li.quantity || 0);
  const qtyLabel = qty > 1 ? ` ×${qty}` : '';
  return variation ? `${lineName} - ${variation}${qtyLabel}` : `${lineName}${qtyLabel}`;
}
